
import { defineComponent } from "vue";
import {
  NavBar,
  ActionSheet,
  Button,
  Overlay,
  Loading,
  Dialog,
  Notify,
  Checkbox,
} from "vant";
import { mapState } from "vuex";
import { Subscription } from "rxjs";
import TagEdit from "@/views/modals/TagEdit.vue";
import { startConversation } from "@/api/chat";
import {
  getDouyinHistoryDetail,
  getWebHistoryDetail,
  getWechatHistoryDetail,
  getWeiboHistoryDetail,
  getKuaishouHistoryDetail,
  getRedbookuHistoryDetail,
} from "@/api/history";
import { callReport, getUserInfoLikeHistoryIndex } from "@/api/common";
import { sanitizeLocation } from "@/utils/location";
import Message from "@/components/messages/Message.vue";
import HistoryDetailPageSubtitle from "@/components/HistoryDetailPageSubtitle.vue";
import HistorySourceDialog from "@/components/HistorySourceDialog.vue";

export default defineComponent({
  components: {
    [NavBar.name]: NavBar,
    [ActionSheet.name]: ActionSheet,
    TagEdit,
    [Button.name]: Button,
    [Overlay.name]: Overlay,
    [Loading.name]: Loading,
    [Dialog.name]: Dialog,
    "yunque-message": Message,
    "history-detail-page-subtitle": HistoryDetailPageSubtitle,
    [Dialog.Component.name]: Dialog.Component,
    "history-source-dialog": HistorySourceDialog,
    [Checkbox.name]: Checkbox,
  },

  data() {
    return {
      actions: [
        { name: "编辑标签", value: "edit-tag" },
        { name: "编辑客资", value: "edit-lead" },
        { name: "访客来源", value: "show-source" },
      ],

      showEditTag: false,
      showLoadingStartingCon: false,

      lastID: "",

      messageList: [] as any[],
      showSourceDialog: false,

      showReportDialog: false,
      isReportAndBlock: true,
      isReportLegal: false,
      isReportPlaceholder: false,

      currentHistoryDetail: null as Record<string, any> | null,
      detailLoading: true,
      detailSub: null as Subscription | null,
      hasEarlierHistory: false,
      earlierHistoryMicrotime: null as string | null,
      loadingEarlierHistory: false,
      hasLaterHistory: false,
      laterHistoryMicrotime: null as string | null,
      loadingLaterHistory: false,
      loadingLatestHistory: false,
      suppressEarlierHistoryAutoLoad: false,
      autoLoadThreshold: 40,
      showScrollToBottomButton: false,
      scrollToBottomButtonThreshold: 120,
      messageListTopSpacerHeight: 0,
    };
  },

  computed: {
    ...mapState({
      companyID: (state: any) => {
        return state.auth.companyID;
      },
      isOnDuty: (state: any) => {
        return state.chat.isOnDuty;
      },
    }),
  },

  watch: {
    "$route.query.uid": {
      handler() {
        this.loadVisitorDetail();
      },
      immediate: true,
    },

    "$route.query.microtime": {
      handler(newValue, oldValue) {
        if (newValue === oldValue) return;
        this.reloadHistoryFromRouteTarget();
      },
    },
  },

  beforeUnmount() {
    this.detailSub?.unsubscribe();
    this.detailSub = null;
  },

  methods: {
    loadVisitorDetail() {
      if (this.$route.name !== "historyDetail") return;

      const uid = String(this.$route.query.uid || "").trim();
      if (!uid) {
        this.detailLoading = false;
        this.$router.replace("/history-list").catch(() => {});
        return;
      }

      this.detailSub?.unsubscribe();
      this.detailLoading = true;
      this.messageList = [];
      this.lastID = "";
      this.currentHistoryDetail = null;
      this.hasEarlierHistory = false;
      this.earlierHistoryMicrotime = null;
      this.loadingEarlierHistory = false;
      this.hasLaterHistory = false;
      this.laterHistoryMicrotime = null;
      this.loadingLaterHistory = false;
      this.loadingLatestHistory = false;
      this.suppressEarlierHistoryAutoLoad = false;
      this.showScrollToBottomButton = false;
      this.messageListTopSpacerHeight = 0;

      this.detailSub = getUserInfoLikeHistoryIndex(uid).subscribe({
        next: (detail: any) => {

          let feName = "";
          if (!detail.name && detail.nickname) {
            feName = detail.nickname;
          } else if (detail.name && !detail.nickname) {
            feName = detail.name;
          } else if (detail.name === detail.nickname) {
            feName = detail.name;
          } else {
            feName = `${detail.name}(${detail.nickname})`;
          }
          detail.feName = feName;

          this.detailLoading = false;
          if (!detail) {
            Dialog.alert({ message: "获取访客信息失败" }).then(() => {
              this.$router.replace("/history-list").catch(() => {});
            });
            return;
          }
          this.currentHistoryDetail = {
            ...detail,
            location: sanitizeLocation(detail.location || ""),
          };
          this.loadInitialHistory();
        },
        error: () => {
          this.detailLoading = false;
          Dialog.alert({ message: "获取访客信息失败" }).then(() => {
            this.$router.replace("/history-list").catch(() => {});
          });
        },
      });
    },

    goBack() {
      if (this.isFromChatSearch()) {
        this.goBackToChatSearch();
        return;
      }

      if (window.history.state && window.history.state.back) {
        this.$router.back();
      } else {
        this.$router.push("/history-list");
      }
    },

    routeQueryText(value: unknown): string {
      const raw = Array.isArray(value) ? value[0] : value;
      return String(raw || "").trim();
    },

    routeQueryParam(key: string): string {
      const routeValue = this.routeQueryText(this.$route.query[key]);
      if (routeValue) return routeValue;
      return new URLSearchParams(window.location.search).get(key) || "";
    },

    isFromChatSearch(): boolean {
      return (
        this.routeQueryParam("from") === "chatSearch" ||
        window.location.href.includes("from=chatSearch")
      );
    },

    chatSearchReturnLocation() {
      const q = this.routeQueryParam("searchQ");
      const tab = this.routeQueryParam("searchTab");
      const query: Record<string, string> = {};

      if (q) {
        query.q = q;
      }
      if (tab === "visitor") {
        query.tab = "visitor";
      }

      return {
        name: "chatSearch",
        query,
      };
    },

    goBackToChatSearch() {
      this.$router.replace(this.chatSearchReturnLocation());
    },

    editLead() {
      if (!this.currentHistoryDetail?.uid) return;
      this.$router.push({
        path: "/edit-lead",
        query: {
          uid: this.currentHistoryDetail.uid,
        },
      });
    },

    startCon() {
      if (!this.isOnDuty) {
        Dialog.alert({
          message: "您已将手机值班状态设置为离线",
        });

        return;
      }

      const info = this.currentHistoryDetail;
      if (!info) return;

      if (info.platform === "web") {
        if (info.has_talk) {
          Dialog.alert({
            message: "对话正在进行中, 无法发起对话",
          });
          return;
        }
      }


      startConversation(info.uid).subscribe(
        (res) => {
          if (res?.data?.result) {
            this.showLoadingStartingCon = true;
            setTimeout(() => {
              this.showLoadingStartingCon = false;
              this.$router.push({
                path: "/chat",
                query: {
                  uid: info.uid,
                },
              });
            }, 3000);
          } else {
            Dialog.alert({
              message: "正在和同事对话中，可前往电脑端查看",
            });
          }
        },
        () => {
          Dialog.alert({
            message: "发起对话失败",
          });
        },
      );
    },

    updateEarlierHistoryMeta(res: any) {
      this.hasEarlierHistory = Boolean(res.hasEarlierHistory);
      this.earlierHistoryMicrotime = this.hasEarlierHistory
        ? this.normalizeMicrotime(res.earlierHistoryMicrotime)
        : null;
    },

    updateLaterHistoryMeta(res: any) {
      this.hasLaterHistory = Boolean(res.hasLaterHistory);
      this.laterHistoryMicrotime = this.hasLaterHistory
        ? this.normalizeMicrotime(res.laterHistoryMicrotime)
        : null;
    },

    lastMessageMicrotime(): string {
      const lastMessage = this.messageList[this.messageList.length - 1];
      return this.messageDomMicrotime(lastMessage);
    },

    prepareLaterHistoryAutoLoad() {
      const microtime = this.lastMessageMicrotime();
      this.hasLaterHistory = Boolean(microtime);
      this.laterHistoryMicrotime = microtime || null;
    },

    resetHistoryPaging() {
      this.hasEarlierHistory = false;
      this.earlierHistoryMicrotime = null;
      this.loadingEarlierHistory = false;
      this.hasLaterHistory = false;
      this.laterHistoryMicrotime = null;
      this.loadingLaterHistory = false;
      this.loadingLatestHistory = false;
      this.suppressEarlierHistoryAutoLoad = false;
      this.showScrollToBottomButton = false;
      this.messageListTopSpacerHeight = 0;
    },

    async loadInitialHistory() {
      const targetMicrotime = this.routeTargetMicrotime();
      this.suppressEarlierHistoryAutoLoad = true;

      try {
        const loaded = await this.getHistory(
          targetMicrotime,
          "",
          targetMicrotime ? 1 : 0,
        );
        if (targetMicrotime && loaded) {
          this.prepareLaterHistoryAutoLoad();
        }

        await this.scrollMessageListToBottomAfterLayout();

        if (targetMicrotime) {
          this.onMessageListScroll();
        } else {
          await this.loadEarlierHistoryUntilScrollable();
          await this.scrollMessageListToBottomAfterLayout();
        }
      } finally {
        this.suppressEarlierHistoryAutoLoad = false;
      }
    },

    async reloadHistoryFromRouteTarget() {
      if (!this.currentHistoryDetail || this.detailLoading) return;

      this.messageList = [];
      this.resetHistoryPaging();
      await this.loadInitialHistory();
    },

    createHistoryRequest(
      lastID = "",
      direction = "",
      includeCursor = 0,
      forceEmptyCursor = false,
    ): any {
      const detail = this.currentHistoryDetail;
      if (!detail) return null;

      const pageDirection = direction || "early";
      let obs: any;

      switch (detail.platform) {
        case "web":
          obs = getWebHistoryDetail(
            detail.uid,
            forceEmptyCursor ? "" : lastID ? lastID : detail.last_microtime,
            this.companyID,
            pageDirection,
            1,
            includeCursor
          );

          break;
        case "wechat":
          obs = getWechatHistoryDetail(
            this.currentHistoryDetail?.uid,
            lastID,
            pageDirection,
            1,
            includeCursor
          );

          break;

        case "weibo":
          obs = getWeiboHistoryDetail(
            this.currentHistoryDetail?.uid,
            lastID,
            pageDirection,
            1,
            includeCursor
          );

          break;
        case "douyin":
          obs = getDouyinHistoryDetail(
            this.currentHistoryDetail?.uid,
            lastID,
            pageDirection,
            1,
            includeCursor
          );

          break;

        case "kuaishou":
          obs = getKuaishouHistoryDetail(
            this.currentHistoryDetail?.uid,
            lastID,
            pageDirection,
            1,
            includeCursor
          );

          break;

        case "redbook":
          obs = getRedbookuHistoryDetail(
            this.currentHistoryDetail?.uid,
            lastID,
            pageDirection,
            1,
            includeCursor
          );
          break;
        default:
          Dialog.alert({
            message: "暂不支持该平台的访客历史",
          });
          return null;
      }

      return obs;
    },

    fetchHistory(
      lastID = "",
      direction = "",
      includeCursor = 0,
      forceEmptyCursor = false,
    ): Promise<any | null> {
      const obs = this.createHistoryRequest(
        lastID,
        direction,
        includeCursor,
        forceEmptyCursor,
      );

      return new Promise((resolve) => {
        if (!obs) {
          resolve(null);
          return;
        }

        obs.subscribe((res: any) => {
          resolve(res);
        }, () => {
          resolve(null);
        });
      });
    },

    async getHistory(
      lastID = "",
      direction = "",
      includeCursor = 0,
      forceEmptyCursor = false,
    ): Promise<boolean> {
      const pageDirection = direction || "early";
      const res = await this.fetchHistory(
        lastID,
        pageDirection,
        includeCursor,
        forceEmptyCursor,
      );

      if (!res) {
        return false;
      }

      if (pageDirection === "later") {
        this.updateLaterHistoryMeta(res);
      } else {
        this.updateEarlierHistoryMeta(res);
      }

      if (!res.data.length) {
        return false;
      }

      if (pageDirection === "later") {
        this.messageList = this.messageList.concat(res.data.slice());
      } else {
        this.messageList = res.data.slice().concat(this.messageList);
      }

      return true;
    },

    normalizeMicrotime(value: unknown): string {
      const raw = Array.isArray(value) ? value[0] : value;
      return String(raw ?? "").trim();
    },

    routeTargetMicrotime(): string {
      return this.normalizeMicrotime(this.$route.query.microtime);
    },

    messageDomMicrotime(message: any): string {
      return this.normalizeMicrotime(
        message?.originalMicrotime ?? message?.microtime ?? message?.cmicrotime,
      );
    },

    messageMicrotimeValues(message: any): string[] {
      return [message?.originalMicrotime, message?.microtime, message?.cmicrotime]
        .map((value) => this.normalizeMicrotime(value))
        .filter(Boolean);
    },

    isTargetMessage(message: any): boolean {
      const targetMicrotime = this.routeTargetMicrotime();
      return (
        !!targetMicrotime &&
        this.messageMicrotimeValues(message).includes(targetMicrotime)
      );
    },

    getMessageListElement(): HTMLElement | null {
      return (this.$refs.messageList as HTMLElement | undefined) || null;
    },

    scrollMessageListToBottom() {
      const list = this.getMessageListElement();
      if (!list) return;
      list.scrollTop = list.scrollHeight;
      this.updateScrollToBottomButtonVisibility(list);
    },

    waitForMessageListLayout(): Promise<void> {
      return new Promise((resolve) => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => resolve());
        });
      });
    },

    async scrollMessageListToBottomAfterLayout() {
      this.messageListTopSpacerHeight = 0;
      await this.$nextTick();
      await this.waitForMessageListLayout();
      const list = this.getMessageListElement();
      if (list) {
        this.messageListTopSpacerHeight = Math.max(
          list.clientHeight - list.scrollHeight,
          0,
        );
      }
      await this.$nextTick();
      await this.waitForMessageListLayout();
      this.scrollMessageListToBottom();
      await this.waitForMessageListLayout();
      this.scrollMessageListToBottom();
    },

    async restoreMessageListScrollTop(el: HTMLElement, scrollTop: number) {
      await this.$nextTick();
      el.scrollTop = scrollTop;
      await this.waitForMessageListLayout();
      el.scrollTop = scrollTop;
      this.updateScrollToBottomButtonVisibility(el);
    },

    messageListItems(el: HTMLElement): HTMLElement[] {
      return Array.from(el.children).filter(
        (child): child is HTMLElement =>
          child instanceof HTMLElement &&
          child.classList.contains("message-container"),
      );
    },

    messageListAnchor(
      el: HTMLElement,
    ): { element: HTMLElement; top: number } | null {
      const listTop = el.getBoundingClientRect().top;
      const element =
        this.messageListItems(el).find(
          (item) => item.getBoundingClientRect().bottom > listTop,
        ) || null;

      if (!element) return null;

      return {
        element,
        top: element.getBoundingClientRect().top,
      };
    },

    async restoreMessageListAnchor(
      el: HTMLElement,
      anchor: { element: HTMLElement; top: number } | null,
      fallbackScrollHeight: number,
      fallbackScrollTop: number,
    ) {
      const restore = () => {
        if (anchor?.element?.isConnected) {
          const currentTop = anchor.element.getBoundingClientRect().top;
          el.scrollTop += currentTop - anchor.top;
          return;
        }

        el.scrollTop = el.scrollHeight - fallbackScrollHeight + fallbackScrollTop;
      };

      await this.$nextTick();
      restore();
      await this.waitForMessageListLayout();
      restore();
      this.updateScrollToBottomButtonVisibility(el);
    },

    messageListDistanceToBottom(el: HTMLElement): number {
      return Math.max(el.scrollHeight - el.scrollTop - el.clientHeight, 0);
    },

    isNearMessageListTop(el: HTMLElement): boolean {
      return el.scrollTop <= this.autoLoadThreshold;
    },

    isNearMessageListBottom(el: HTMLElement): boolean {
      return this.messageListDistanceToBottom(el) <= this.autoLoadThreshold;
    },

    isMessageListScrollable(el: HTMLElement): boolean {
      return el.scrollHeight > el.clientHeight + this.autoLoadThreshold;
    },

    updateScrollToBottomButtonVisibility(el?: HTMLElement | null) {
      const target = el || this.getMessageListElement();
      this.showScrollToBottomButton = Boolean(
        target &&
          this.messageListDistanceToBottom(target) >
            this.scrollToBottomButtonThreshold,
      );
    },

    onMessageListScroll() {
      const el = this.getMessageListElement();
      if (!el) return;

      this.updateScrollToBottomButtonVisibility(el);

      if (
        !this.suppressEarlierHistoryAutoLoad &&
        this.isNearMessageListTop(el)
      ) {
        this.loadEarlierHistory();
      }

      if (this.isNearMessageListBottom(el)) {
        this.loadLaterHistory();
      }
    },

    async handleScrollToBottomClick() {
      await this.loadLatestHistoryFromScrollButton();
    },

    latestMessageKeys(messages: any[]): Set<string> {
      return new Set(
        messages
          .map((message: any) => this.messageDomMicrotime(message))
          .filter(Boolean),
      );
    },

    async loadLatestHistoryFromScrollButton() {
      if (!this.currentHistoryDetail || this.loadingLatestHistory) {
        return;
      }

      this.loadingLatestHistory = true;
      const previousSuppressEarlierHistoryAutoLoad =
        this.suppressEarlierHistoryAutoLoad;
      this.suppressEarlierHistoryAutoLoad = true;

      try {
        const res = await this.fetchHistory("", "early", 0, true);
        if (!res) return;

        this.updateEarlierHistoryMeta(res);
        this.hasLaterHistory = false;
        this.laterHistoryMicrotime = null;

        const latestMessages = res.data.slice();
        if (!latestMessages.length) {
          await this.scrollMessageListToBottomAfterLayout();
          return;
        }

        const latestKeys = this.latestMessageKeys(latestMessages);
        this.messageList = this.messageList
          .filter((message: any) => !latestKeys.has(this.messageDomMicrotime(message)))
          .concat(latestMessages);

        await this.scrollMessageListToBottomAfterLayout();
        this.messageList = latestMessages;
        await this.scrollMessageListToBottomAfterLayout();
        this.showScrollToBottomButton = false;
      } finally {
        this.suppressEarlierHistoryAutoLoad =
          previousSuppressEarlierHistoryAutoLoad;
        this.loadingLatestHistory = false;
      }
    },

    async loadEarlierHistoryUntilScrollable() {
      let el = this.getMessageListElement();
      let loadCount = 0;

      while (
        el &&
        !this.isMessageListScrollable(el) &&
        this.hasEarlierHistory &&
        loadCount < 3
      ) {
        const loaded = await this.loadEarlierHistory();
        if (!loaded) break;
        await this.$nextTick();
        el = this.getMessageListElement();
        loadCount += 1;
      }
    },

    async loadEarlierHistory(options: { preserveScroll?: boolean } = {}) {
      if (
        !this.currentHistoryDetail ||
        !this.hasEarlierHistory ||
        this.loadingEarlierHistory
      ) {
        return false;
      }

      if (this.messageListTopSpacerHeight) {
        this.messageListTopSpacerHeight = 0;
        await this.$nextTick();
      }

      const el = this.getMessageListElement();
      const anchor = el ? this.messageListAnchor(el) : null;
      const previousScrollHeight = el?.scrollHeight ?? 0;
      const previousScrollTop = el?.scrollTop ?? 0;

      this.loadingEarlierHistory = true;
      try {
        const loaded = await this.getHistory(
          this.earlierHistoryMicrotime || "",
          "early",
        );

        if (loaded && options.preserveScroll !== false && el) {
          await this.restoreMessageListAnchor(
            el,
            anchor,
            previousScrollHeight,
            previousScrollTop,
          );
        } else {
          await this.$nextTick();
        }

        return loaded;
      } finally {
        this.loadingEarlierHistory = false;
      }
    },

    async loadLaterHistory() {
      if (
        !this.currentHistoryDetail ||
        !this.hasLaterHistory ||
        this.loadingLaterHistory
      ) {
        return false;
      }

      const microtime = this.laterHistoryMicrotime || this.lastMessageMicrotime();
      if (!microtime) {
        this.hasLaterHistory = false;
        this.laterHistoryMicrotime = null;
        return false;
      }

      const el = this.getMessageListElement();
      const previousScrollTop = el?.scrollTop ?? 0;

      this.loadingLaterHistory = true;
      try {
        const loaded = await this.getHistory(microtime, "later");
        if (loaded && el) {
          await this.restoreMessageListScrollTop(el, previousScrollTop);
        } else {
          await this.$nextTick();
        }
        return loaded;
      } finally {
        this.loadingLaterHistory = false;
      }
    },

    recallMessage($event: any) {
      // @ts-ignore 莫名其妙的错误
      this.messageList = this.messageList.map((item: any) => {
        if (item.microtime === $event.microtime) {
          item.recalled = true;
        }

        return item;
      });
    },

    report() {
      this.showReportDialog = true;
    },

    doReport() {
      const detail = this.currentHistoryDetail;
      if (!detail) return;
      callReport({
        uid: detail.uid,
        reason: "手机端举报",
        platform: detail.platform,
        ip: detail.ip || undefined,
        blocked: this.isReportAndBlock ? 1 : 0,
        reported: this.isReportLegal ? 1 : 0,
      }).subscribe(() => {
        Notify({ type: "success", message: "操作成功" });
        this.showReportDialog = false;

        if (this.isReportAndBlock) {
          this.$router.replace("/history-list");
        }
      });
    },
  },
});
